
export enum ReminderHostType {
  CLAIMS = 'claims',
  POLICIES = 'policies',
}

export type ReminderDateMode = 'absolute' | 'relative';
export type ReminderOffsetDirection = 'before' | 'after';

export interface ReminderDateDefinition {
  mode: ReminderDateMode;
  offsetDays?: number;
  offsetDirection?: ReminderOffsetDirection;
}

export interface ClaimsDocumentReminderJsonPayload {
  documentId: string; // ID of the document related to the claim
  reminderDate: string; // ISO string format date
  note?: string; // Additional note for the reminder
  dateDefinition?: ReminderDateDefinition;
  [key: string]: any; // Allow for additional fields in the payload
}

export interface PolicyFieldReminderJsonPayload {
  reminderDate: string; // ISO string format date
  note?: string; // Additional note for the reminder
  dateDefinition?: ReminderDateDefinition;
  [key: string]: any; // Allow for additional fields in the payload
}


/**
 * Reminder model for frontend
 */
export interface Reminder {
  id: string; // Primary key - UUID
  clientId: string;
  subsidiaryId?: string | null;
  userId: string;
  hostType: ReminderHostType;
  hostId: string;
  jsonPayload: ClaimsDocumentReminderJsonPayload | PolicyFieldReminderJsonPayload;
  isActive: boolean;
  isDeleted: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

/**
 * Reminder creation/update DTO
 */
export interface ReminderFormData {
  id: string;
  clientId?: string;
  subsidiaryId?: string | null;
  userId?: string;
  hostType?: ReminderHostType;
  hostId?: string; 
  jsonPayload: ClaimsDocumentReminderJsonPayload | PolicyFieldReminderJsonPayload;
  isActive?: boolean;
}
